/* Component Dependencies */
var AriesComponent = require("libs/aries-component");
var checkInNowTemplate = require("templates/checkInNow.hbs");
var $ = require("jquery");
var PubSub = require("libs/pub-sub");

PubSub.register(
	AriesComponent.extend({
		type: "checkInNow",
		template: {
			checkInNow: checkInNowTemplate,
		},
		events: {},
		bindEvents: function ($) {
			var _self = this;
			var impressionVal = "";
			if (_self.$el.find(".check-in-button").length > 0) {
				if(!_self.$el.data('modifyCheckIn')) {
					switch (window.location.pathname) {
						case "/reservation/findReservationDetail.mi": {
							window.impressionTrack ? window.impressionTrack(
								"event168|evar48=MER-web-checkintile-findresdetail"
							) : '';
							impressionVal = "evar48=MER-web-checkintile-findresdetail";
							break;
						}
						case "/reservation/changeConfirmation.mi": {
							window.impressionTrack ? window.impressionTrack(
								"event168|evar48=MER-web-checkintile-change-confo"
							) : '';
							impressionVal = "evar48=MER-web-checkintile-change-confo";
							break;
						}
						default: {
						}
					}
				} else {
					switch (window.location.pathname) {
						case "/reservation/findReservationDetail.mi": {
							window.impressionTrack ? window.impressionTrack(
								"event168|evar48=MER-web-modifycheckintile-findresdetail"
							) : '';
							impressionVal = "evar48=MER-web-modifycheckintile-findresdetail";
							break;
						}
						case "/reservation/changeConfirmation.mi": {
							window.impressionTrack ? window.impressionTrack(
								"event168|evar48=MER-web-modifycheckintile-change-confo"
							) : '';
							impressionVal = "evar48=MER-web-modifycheckintile-change-confo";
							break;
						}
						default: {
						}
					}
				}
			}

			_self.$el.find(".custom_click_track.check-in-button").each(function () {
				$(this).attr(
					"custom_click_track_value",
					"Upcoming Reservation Tile|Check-In Now Button|internal|event167," +
						impressionVal
				);
			});
		},
	})
);
